import * as React from "react";

const SvgTrendingup = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M13 7.5h8M21 7.5v8M21 7.5l-8 8-4-4-6 6" />
    </g>
  </svg>
);

export default SvgTrendingup;
